import { css } from 'styled-components';
import {
  variantStyleMap as textVariantStyleMap,
  variantElementMap as textVariantElementMap,
} from '../../../components/Text/Text';
import {
  variantStyleMap as headingVariantStyleMap,
  variantElementMap as headingVariantElementMap,
} from '../../../components/Heading/Heading';

const typographicVariantStyleMap = { ...textVariantStyleMap, ...headingVariantStyleMap };

export type TypographicVariant = keyof typeof typographicVariantStyleMap;

export const getTypographicStyles = (variant: TypographicVariant) => {
  return css`
    ${typographicVariantStyleMap[variant]}
    font-family: var(--font-family);
    font-size: var(--font-size);
    font-weight: var(--font-weight);
    line-height: var(--line-height);
  `;
};

const typographicVariantElementMap = { ...textVariantElementMap, ...headingVariantElementMap };

export const getDefaultTypographicElement = (variant: TypographicVariant) => {
  return typographicVariantElementMap[variant] ?? 'span';
};
